module.exports = __webpack_public_path__ + "static/conduccion---panel-de-control-60bcf723143300a2767ef270b7c4016a.jpg";